module.exports = __webpack_public_path__ + "img/1.8d438ee1.png";